import React, { useContext } from 'react';
import { Row, Col, Nav } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { TfiPanel, TfiServer, TfiArrowCircleLeft, TfiArrowCircleRight } from 'react-icons/tfi';
import PropTypes from 'prop-types';
import { CurrencyContext } from '../../utils/currencyContext';
import { WebPlanContext } from '../../utils/webPlanContext';
import { CloudPlanContext } from '../../utils/cloudPlanContext';
import getCurrencySign from '../../utils/getCurrencySign';
import { webHostingCloud, webHostingPlans } from '../../resources/static/index';
import cpanelLogo from '../../assets/img/cpanel.png';

function PlanColumns({ period }) {
    const { currentCurrency } = useContext(CurrencyContext);
    const { currentWebPlan } = useContext(WebPlanContext);
    const { currentCloudPlan, setGlobalCloudPlan } = useContext(CloudPlanContext);
    const { i18n, t } = useTranslation();
    const changeCloudPlan = (isNext) => {
        setGlobalCloudPlan((prevPlan) => {
            if (isNext) {
                return (prevPlan % 3) + 1;
            }
            return ((prevPlan + 1) % 3) + 1;
        });
    };
    const getCurrencyCode = (currency) => {
        let currencyCode = 1;

        if (currency === 'usd') {
            currencyCode = 4;
        } else if (currency === 'gbp') {
            currencyCode = 5;
        }

        return currencyCode;
    };

    const getCloudProductId = (cloudPlan) => 180 + cloudPlan;

    const getPeriodDiscount = (per) => {
        let discount = null;

        if (per === 2) {
            discount = '10%';
        } else if (per === 3) {
            discount = '15%';
        }

        return discount;
    };
    const getBillingCycle = (currentPlan) => {
        let currencyCode = 'annually';

        if (currentPlan === 'two') {
            currencyCode = 'biennially';
        } else if (currentPlan === 'three') {
            currencyCode = 'triennially';
        }

        return currencyCode;
    };
    const roundToTwo = (num) => parseFloat(num.toFixed(2));
    const sign = getCurrencySign(currentCurrency);
    const dataCloud = webHostingCloud[`cloud_${currentCloudPlan}`];
    const dataCurrency = webHostingPlans[currentCurrency];
    const data = dataCurrency[`year_${period}`];
    const isNotFirstPeriod = period > 1;
    const yearCoefficient = 12 * period;
    const currentLanguage = i18n.language;
    const isFR = currentLanguage === 'fr';

    return (
        <Row>
            <Col lg={4} md={12} xs={12}>
                <div className="plan-card">
                    <h2 className="plan-title">Solo</h2>
                    <p className="plan-text">{t('web-hosting-page.plans-column.text')}</p>
                    <div className="plan-price">
                        <p className="price-info">
                            <span className="price-home">
                                {data.solo}
                                <sup>{sign}</sup>
                            </span>
                            /{t('titles.month')}
                        </p>
                        <p className="price-year">
                            {isNotFirstPeriod && (
                                <del>
                                    {roundToTwo(dataCurrency.year_1.solo * yearCoefficient)}
                                    {sign}
                                </del>
                            )}
                            &nbsp;
                            <strong>
                                {isNotFirstPeriod
                                    ? roundToTwo(data.solo * yearCoefficient)
                                    : roundToTwo(dataCurrency.year_1.solo * yearCoefficient)}
                                {sign}
                            </strong>
                            &nbsp;{t('titles.for')} {period}{' '}
                            {period > 1 ? t('titles.years') : t('titles.year')}
                        </p>
                    </div>
                    {isNotFirstPeriod && (
                        <div className="price-save">
                            {t('titles.save')} {getPeriodDiscount(period)}
                        </div>
                    )}
                    <div className="price-content">
                        <ul>
                            <li className="plan-count">
                                <img src={cpanelLogo} alt="pricing-icon" /> cPanel+
                            </li>
                            <li className="flex-container">
                                <div className="cpu-ram">
                                    <div>
                                        <TfiPanel />
                                    </div>
                                    <div>
                                        <strong>1</strong> {t('web-hosting-page.plans-column.cpu')}
                                    </div>
                                </div>
                                <div className="cpu-ram">
                                    <div>
                                        <TfiServer />
                                    </div>
                                    <div>
                                        <strong>2{t('web-hosting-page.plans-column.gb')}</strong>{' '}
                                        RAM
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="plan-feature">
                        <ul>
                            <li className="plan-count">
                                <p>
                                    <strong>1</strong>{' '}
                                    {t('web-hosting-page.plans-column.property-1')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    <strong>50{t('web-hosting-page.plans-column.gb')}</strong>{' '}
                                    {t('web-hosting-page.plans-column.property-2')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    <strong>30</strong>{' '}
                                    {t('web-hosting-page.plans-column.property-3')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    <strong>10</strong>{' '}
                                    {t('web-hosting-page.plans-column.property-4')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {isFR
                                        ? `${t('web-hosting-page.plans-column.property-5')} `
                                        : null}
                                    <strong>{t('web-hosting-page.plans-column.weekly')}</strong>{' '}
                                    {!isFR ? t('web-hosting-page.plans-column.property-5') : null}
                                </p>
                            </li>
                            <li>
                                <p>-</p>
                            </li>
                        </ul>
                    </div>
                    <Nav className="common-nav-button">
                        <Nav.Link
                            className="navbar-brand"
                            href={`https://obambu.com/order/?pid=179&language=${isFR ? 'french' : 'english'}&currency=${getCurrencyCode(currentCurrency)}&billingcycle=${getBillingCycle(currentWebPlan)}`}
                            rel="noopener noreferrer"
                        >
                            {t('buttons.order-now')}
                        </Nav.Link>
                    </Nav>
                </div>
            </Col>
            <Col lg={4} md={12} xs={12}>
                <div className="plan-card">
                    <h2 className="plan-title">Multisite</h2>
                    <p className="plan-text">{t('web-hosting-page.plans-column.text-2')}</p>
                    <div className="plan-price">
                        <p className="price-info">
                            <span className="price-home">
                                {data.multisite}
                                <sup>{sign}</sup>
                            </span>
                            /{t('titles.month')}
                        </p>
                        <p className="price-year">
                            {isNotFirstPeriod && (
                                <del>
                                    {roundToTwo(dataCurrency.year_1.multisite * yearCoefficient)}
                                    {sign}
                                </del>
                            )}
                            &nbsp;
                            <strong>
                                {isNotFirstPeriod
                                    ? roundToTwo(data.multisite * yearCoefficient)
                                    : roundToTwo(dataCurrency.year_1.multisite * yearCoefficient)}
                                {sign}
                            </strong>
                            &nbsp;{t('titles.for')} {period}{' '}
                            {period > 1 ? t('titles.years') : t('titles.year')}
                        </p>
                    </div>
                    {isNotFirstPeriod && (
                        <div className="price-save">
                            {t('titles.save')} {getPeriodDiscount(period)}
                        </div>
                    )}
                    <div className="price-content">
                        <ul>
                            <li className="plan-count">
                                <img src={cpanelLogo} alt="pricing-icon" /> cPanel+
                            </li>
                            <li className="flex-container">
                                <div className="cpu-ram">
                                    <div>
                                        <TfiPanel />
                                    </div>
                                    <div>
                                        <strong>1</strong> {t('web-hosting-page.plans-column.cpu')}
                                    </div>
                                </div>
                                <div className="cpu-ram">
                                    <div>
                                        <TfiServer />
                                    </div>
                                    <div>
                                        <strong>2{t('web-hosting-page.plans-column.gb')}</strong>{' '}
                                        RAM
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="plan-feature">
                        <ul>
                            <li className="plan-count">
                                <p>
                                    <strong>20</strong>{' '}
                                    {t('web-hosting-page.plans-column.property-6')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    <strong>100{t('web-hosting-page.plans-column.gb')}</strong>{' '}
                                    {t('web-hosting-page.plans-column.property-2')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    <strong>200</strong>{' '}
                                    {t('web-hosting-page.plans-column.property-3')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    <strong>100</strong>{' '}
                                    {t('web-hosting-page.plans-column.property-4')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {isFR
                                        ? `${t('web-hosting-page.plans-column.property-5')} `
                                        : null}
                                    <strong>{t('web-hosting-page.plans-column.weekly')}</strong>{' '}
                                    {!isFR
                                        ? `${t('web-hosting-page.plans-column.property-5')} `
                                        : null}
                                </p>
                            </li>
                            <li>
                                <p>-</p>
                            </li>
                        </ul>
                    </div>
                    <Nav className="common-nav-button">
                        <Nav.Link
                            className="navbar-brand"
                            href={`https://obambu.com/order/?pid=180&language=${isFR ? 'french' : 'english'}&currency=${getCurrencyCode(currentCurrency)}&billingcycle=${getBillingCycle(currentWebPlan)}`}
                            rel="noopener noreferrer"
                        >
                            {t('buttons.order-now')}
                        </Nav.Link>
                    </Nav>
                </div>
            </Col>
            <Col lg={4} md={12} xs={12}>
                <div className="plan-card active">
                    <div className="badge-active">
                        {t('web-hosting-page.plans-column.active-badge')}
                    </div>
                    <h2 className="plan-title">
                        Cloud<span>Pro</span> <span className="cloudpro-g">{dataCloud.title}</span>
                    </h2>
                    <p className="plan-text">{t('web-hosting-page.plans-column.text-3')}</p>
                    <div className="plan-price">
                        <p className="price-info">
                            <span className="price-home">
                                {data[`cloud_${currentCloudPlan}`]}
                                <sup>{sign}</sup>
                            </span>
                            /{t('titles.month')}
                        </p>
                        <p className="price-year">
                            {isNotFirstPeriod && (
                                <del>
                                    {roundToTwo(
                                        dataCurrency.year_1[`cloud_${currentCloudPlan}`] *
                                            yearCoefficient
                                    )}
                                    {sign}
                                </del>
                            )}
                            &nbsp;
                            <strong>
                                {isNotFirstPeriod
                                    ? roundToTwo(
                                          data[`cloud_${currentCloudPlan}`] * yearCoefficient
                                      )
                                    : roundToTwo(
                                          dataCurrency.year_1[`cloud_${currentCloudPlan}`] *
                                              yearCoefficient
                                      )}
                                {sign}
                            </strong>
                            &nbsp;{t('titles.for')} {period}{' '}
                            {period > 1 ? t('titles.years') : t('titles.year')}
                        </p>
                    </div>
                    {isNotFirstPeriod && (
                        <div className="price-save">
                            {t('titles.save')} {getPeriodDiscount(period)}
                        </div>
                    )}
                    <div className="price-content">
                        <ul>
                            <li className="plan-count">
                                <img src={cpanelLogo} alt="pricing-icon" /> cPanel+
                            </li>
                            <li className="flex-container">
                                <button
                                    id="left-arrow"
                                    className="side-button"
                                    onClick={() => changeCloudPlan()}
                                    type="button"
                                >
                                    {' '}
                                    <TfiArrowCircleLeft />
                                </button>
                                <div className="cpu-ram cloudpro">
                                    <div>
                                        <TfiPanel />
                                    </div>
                                    <div>
                                        <strong className="slider-option-cpu">
                                            {dataCloud.cpu}
                                        </strong>{' '}
                                        {t('web-hosting-page.plans-column.cpu')}
                                    </div>
                                </div>
                                <div className="cpu-ram cloudpro">
                                    <div>
                                        <TfiServer />
                                    </div>
                                    <div>
                                        <strong className="slider-option-ram">
                                            {isFR ? dataCloud.ram_fr : dataCloud.ram}
                                        </strong>{' '}
                                        RAM
                                    </div>
                                </div>
                                <button
                                    id="right-arrow"
                                    className="side-button"
                                    onClick={() => changeCloudPlan(true)}
                                    type="button"
                                >
                                    {' '}
                                    <TfiArrowCircleRight />
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div className="plan-feature">
                        <ul>
                            <li className="plan-count">
                                <p style={{ textTransform: 'capitalize' }}>
                                    {isFR
                                        ? `${t('web-hosting-page.plans-column.property-6')} `
                                        : null}
                                    <strong>{t('web-hosting-page.plans-column.unlimited')}</strong>{' '}
                                    {!isFR
                                        ? `${t('web-hosting-page.plans-column.property-6')} `
                                        : null}
                                </p>
                            </li>
                            <li>
                                <p>
                                    <strong className="slider-option-space">
                                        {isFR ? dataCloud.ssd_fr : dataCloud.ssd}
                                    </strong>{' '}
                                    {t('web-hosting-page.plans-column.property-2')}
                                </p>
                            </li>
                            <li>
                                <p style={{ textTransform: 'capitalize' }}>
                                    {isFR
                                        ? `${t('web-hosting-page.plans-column.property-3')} `
                                        : null}
                                    <strong>{t('web-hosting-page.plans-column.unlimited')}</strong>{' '}
                                    {!isFR
                                        ? `${t('web-hosting-page.plans-column.property-3')} `
                                        : null}
                                </p>
                            </li>
                            <li>
                                <p style={{ textTransform: 'capitalize' }}>
                                    {isFR
                                        ? `${t('web-hosting-page.plans-column.property-4')} `
                                        : null}
                                    <strong>{t('web-hosting-page.plans-column.unlimited')}</strong>{' '}
                                    {!isFR
                                        ? `${t('web-hosting-page.plans-column.property-4')} `
                                        : null}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {isFR
                                        ? `${t('web-hosting-page.plans-column.property-5')} `
                                        : null}
                                    <strong>{t('web-hosting-page.plans-column.daily')}</strong>{' '}
                                    {!isFR
                                        ? `${t('web-hosting-page.plans-column.property-5')} `
                                        : null}
                                </p>
                            </li>
                            <li>
                                <p>
                                    <strong> Node.JS, Ruby, Python </strong> {isFR ? '' : 'Apps'}
                                </p>
                            </li>
                        </ul>
                    </div>
                    <Nav className="common-nav-button">
                        <Nav.Link
                            className="navbar-brand"
                            href={`https://obambu.com/order/?pid=${getCloudProductId(currentCloudPlan)}&language=${isFR ? 'french' : 'english'}&currency=${getCurrencyCode(currentCurrency)}&billingcycle=${getBillingCycle(currentWebPlan)}`}
                            rel="noopener noreferrer"
                        >
                            {t('buttons.order-now')}
                        </Nav.Link>
                    </Nav>
                </div>
            </Col>
        </Row>
    );
}

PlanColumns.propTypes = {
    period: PropTypes.number
};

PlanColumns.defaultProps = {
    period: 1
};

export default PlanColumns;
